import styled, { css, keyframes } from 'styled-components';
import { breakpoints } from 'modules/breakpoints';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
import { responsiveProperty } from 'modules/utils/responsiveProperty';
const deprecatedSizes = {
    small: pxToRem(480),
    compact: pxToRem(600),
    large: pxToRem(800),
};
const sizes = Object.assign({ sm: pxToRem(480), md: pxToRem(600), lg: pxToRem(800), xl: `calc(100dvw - calc(2 * ${theme.spacing['7xl']}))` }, deprecatedSizes);
const slideUpIn = keyframes `
  0% {
    opacity: 0;
    transform: translateY(${pxToRem(6)});
  }

  80% {
    opacity: 1;
  }

  100% {
    transform: translateY(0);
  }
`;
export const DialogContainer = styled.div `
  width: calc(100dvw - calc(2 * ${theme.spacing.xl}));
  height: calc(100dvh - calc(2 * ${theme.spacing.xl}));
  max-height: calc(100dvh - calc(2 * ${theme.spacing.xl}));
  margin: ${theme.spacing.xl} auto;

  & > * {
    /* Card needs a fixed height to make overflow: hidden work. Otherwise Card may grow too tall */
    max-height: inherit;
    height: inherit;
  }

  ${({ $animate }) => $animate &&
    css `
      animation: 0.5s ${slideUpIn} forwards;
    `}

  ${breakpoints.desktop} {
    width: ${(props) => sizes[props.$size]};
    ${(props) => props.$height && responsiveProperty('height', props.$height)};
    max-height: 80dvh;
    max-width: ${pxToRem(1400)};
    margin: 10dvh auto;
  }
`;
